<template>
  <div class="content" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 1)">
  </div>
</template>

<script>
import autoLogin from '@/minixs/h5sWebLogin/autoLogin'
export default {
  name: 'H5sWeb1008AutoLogin',

  data() {
    return {
      loading: true,
      requestUrl: process.env.VUE_APP_request_url
    }
  },

  mounted() {
    // 拿token 做验签
    this.getTokenToAuth()
  },

  methods: {
    async getTokenToAuth() {
      const cur_query = this.$route.query
      this.accessToken = cur_query['accessToken'] || ''
      if (!this.accessToken) {
        this.$router.push('/login')
      }
      // 验签
      const resSSO = await this.$http.post(
        `${this.requestUrl}/js_ssoserver/sso/verifytoken`,
        {
          accessToken: cur_query['accessToken']
        }
      )
      if (resSSO.status === 200 && resSSO.data.code == '200') {
        // 自动登录
        autoLogin
          .autoLogin()
          .then(res => {
            this.$router.push({
              path: 'Dashboard'
            })
          })
          .catch(e => {
            this.$router.push('/login')
          })
      } else {
        this.$router.push('/login')
      }
    }
  }
}

//  Promise.all([
//         // 验签
//         this.$http.post(`${this.requestUrl}/js_ssoserver/sso/verifytoken`, {
//           accessToken: cur_query['accessToken']
//         }),
//         // 自动登录
//         autoLogin.autoLogin()
//       ])
//         .then(([resSSO, resLogin]) => {
//           if (resSSO.status === 200 && resSSO.data.code == '200') {
//             this.$router.push({
//               path: 'Dashboard'
//             })
//           } else {
//             this.$router.push('/login')
//           }
//         })
//         .catch(e => {
//           this.$router.push('/login')
//         })
</script>

<style lang="scss" scoped>
.content {
  width: 100vw;
  height: 100vh;
}
</style>